export default function AboutSection() {
  return (
    <section id="about" className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-4xl mx-auto">
        <div className="text-center mb-10 md:mb-12">
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-100 mb-3">
            关于影院
          </h2>
        </div>

        <div className="bg-background-200/40 rounded-lg border border-background-300/30 p-6 md:p-10">
          <p className="text-sm md:text-base text-foreground-300 leading-relaxed mb-4">
            五姑娘影院诞生于对电影的纯粹热爱。我们是一个由资深影迷组成的团队，深知每一位观影者对于高清画质和流畅播放的期待。自上线以来，我们始终坚持<strong className="text-primary-400 font-medium">完全免费、无需注册</strong>的原则，为全球华语观众提供最新、最全的电影资源。
          </p>
          <p className="text-sm md:text-base text-foreground-300 leading-relaxed mb-4">
            我们的影片库涵盖动作片、喜剧片、科幻片、爱情片、悬疑片、动画片、纪录片、战争片、犯罪片等各大类型，从IMDb高分经典到最新院线热映大片，应有尽有。所有影片均采用<strong className="text-primary-400 font-medium">高速CDN加速分发技术</strong>，确保您无论身处何地，都能享受零缓冲、零卡顿的观影体验。
          </p>
          <p className="text-sm md:text-base text-foreground-300 leading-relaxed">
            五姑娘影院电影大全每日保持<strong className="text-primary-400 font-medium">50部以上影片的更新频率</strong>，紧跟全球影视热点。我们不仅提供观影服务，更希望打造一个让影迷交流、分享、发现好片的社区。用心选片，用爱发电——这就是五姑娘影院的初心。
          </p>
        </div>
      </div>
    </section>
  );
}